import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { FloatingWhatsApp } from "@/components/layout/FloatingWhatsApp";
import { ScrollToTop } from "@/components/common/ScrollToTop";
import { SEO } from "@/components/SEO";
import { organizationSchema, websiteSchema } from "@/lib/schema";
import { useWhatsAppPopup } from "@/hooks/useWhatsAppPopup";

const WhatsAppPopup = lazy(() => import("@/components/common/WhatsAppPopup"));

export const SiteLayout = () => {
  const { isOpen, dismissPopup, handleWhatsAppClick } = useWhatsAppPopup();

  return (
    <div className="App min-h-screen bg-lux-ivory">
      <SEO schema={[organizationSchema(), websiteSchema()]} />
      <ScrollToTop />
      <Navbar />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      {!isOpen && <FloatingWhatsApp />}
      <Suspense fallback={null}>
        <WhatsAppPopup
          isOpen={isOpen}
          onClose={dismissPopup}
          onWhatsAppClick={handleWhatsAppClick}
        />
      </Suspense>
    </div>
  );
};

